import { StatusBar } from "expo-status-bar";
import React from "react";
import PropTypes from "prop-types";
import {
  StyleSheet,
  View,
  ScrollView,
  ActivityIndicator,
  TouchableWithoutFeedback,
  Platform,
  TextInput,
  Dimensions
} from "react-native";
import TouchableOpacity from "app/components/TouchableOpacity";
import Text from "app/components/Text";
import Value from "app/components/Value";
import Icon from "app/components/Icon";
// import Canvas from 'app/components/Canvas'
import apiActions from "app/utils/apiActions";
import storageActions from "app/utils/storageActions";
import prefActions from "app/utils/prefActions";
import * as RootNavigation from "app/utils/RootNavigation.js";
import calendarActions from "app/utils/calendarActions";
import textHelpers from "app/utils/textHelpers";
import locationHelpers from "app/utils/locationHelpers";
import notificationHelpers from "app/utils/notificationHelpers";
import { styleSheet, colors, sizes } from "app/utils/styleSheet";

import Autocomplete from "app/components/Autocomplete";
import ValueInspector from "app/components/ValueInspector";
import MomentBullet from "app/components/chapter/MomentBullet";

import {
  Ionicons,
  MaterialCommunityIcons,
  MaterialIcons,
  AntDesign,
  FontAwesome5,
  Fontisto,
  Entypo,
  Octicons,
  Foundation,
  FontAwesome
} from "@expo/vector-icons";

export default class Settings extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      fonts: [],
      icon: null,
      color: null,
      events: [],
      createdValues: [],
      composing: false,
      composingId: null,
      parent: null,
      parentQuery: "",
      lightScheme: "parchment",
      darkScheme: "muted",
      selectedSchemeMode: "auto",
      gCalConnected: false,
      gCalServiceAccountJson: ""
    };
  }

  async componentDidMount() {
    console.log("Settings mounted");
    let gCalConnected = await calendarActions.isConnected();
    this.setState({ gCalConnected });
    let cached = await calendarActions.getCachedEvents();
    if (cached.length > 0) this.setState({ events: cached });
    this.getEvents(true);
  }

  render() {
    let { navigation } = this.props;
    let { lightScheme, darkScheme, selectedSchemeMode } = this.state;
    let lightSchemeOptions = ["parchment", "clarity", "newspaper"];
    let darkSchemeOptions = ["bold", "muted", "newspaper_dark"];
    let schemeModeOptions = ["auto", "light", "dark"];
    return (
      <ScrollView style={styles.container}>
        <Text bold style={styles.header}>
          Color Scheme
        </Text>
        <View style={styles.row}>
          <Text bold style={styles.label}>
            Mode:
          </Text>
          {schemeModeOptions.map((opt, i) => (
            <Text
              key={i}
              button
              selectedButton={selectedSchemeMode == opt}
              onPress={() => this.setSchemeMode(opt)}
            >
              {textHelpers.capitalize(opt.split("_")[0])}
            </Text>
          ))}
        </View>
        <View style={styles.row}>
          <Text bold style={styles.label}>
            Light:
          </Text>
          {lightSchemeOptions.map((opt, i) => (
            <Text
              key={i}
              button
              selectedButton={lightScheme == opt}
              onPress={() => this.setLightScheme(opt)}
            >
              {textHelpers.capitalize(opt.split("_")[0])}
            </Text>
          ))}
        </View>
        <View style={styles.row}>
          <Text bold style={styles.label}>
            Dark:
          </Text>
          {darkSchemeOptions.map((opt, i) => (
            <Text
              key={i}
              button
              selectedButton={darkScheme == opt}
              onPress={() => this.setDarkScheme(opt)}
            >
              {textHelpers.capitalize(opt.split("_")[0])}
            </Text>
          ))}
        </View>
        <View style={styles.spacer} />
        <Text bold style={styles.header}>
          Calendar Integration
        </Text>
        {this.state.gCalConnected ? (
          <View style={styles.row}>
            <Text>Connected</Text>
            <Text button onPress={this.getEvents}>
              Sync Now
            </Text>
            <Text button onPress={this.disconnectGCal}>
              Disconnect
            </Text>
          </View>
        ) : (
          <View>
            <TextInput
              placeholder="Paste service account JSON here"
              value={this.state.gCalServiceAccountJson}
              onChangeText={(gCalServiceAccountJson) =>
                this.setState({ gCalServiceAccountJson })
              }
              multiline
              style={[styles.tokenInput, { height: 100 }]}
            />
            <Text button onPress={this.saveGCalCredentials}>
              Save & Connect
            </Text>
          </View>
        )}
        {this.renderEvents()}
        <View style={styles.spacer} />
        <Text bold style={styles.header}>
          Debug
        </Text>
        <View style={styles.row}>
          <Text button onPress={() => RootNavigation.navigate("IconTest")}>
            Icon/Color Test
          </Text>
          <Text
            button
            onPress={() => notificationHelpers.scheduleNotification()}
          >
            Test Notification
          </Text>
          <Text
            button
            onPress={async () => {
              try {
                const token =
                  await notificationHelpers.registerForPushNotificationsAsync();
                if (token) {
                  alert(`Device Token:\n\n${token}`);
                } else {
                  alert("No token received. Check console for errors.");
                }
              } catch (error) {
                alert(`Error getting token:\n\n${error.message}`);
              }
            }}
          >
            Get Device Token
          </Text>
          <Text
            button
            onPress={async () => {
              let location = await locationHelpers.getLocation();
              if (!!location?.coords) {
                alert(
                  `${location.coords.latitude}, ${location.coords.longitude}`
                );
              }
            }}
          >
            Get Location
          </Text>
        </View>
        <View style={styles.spacer} />
        {/*<Text bold style={styles.header}>
          Account
        </Text>
        <View style={styles.row}>
          <Text button onPress={this.deleteAccount}>
            Log out
          </Text>
          <Text button onPress={this.deleteAccount}>
            Log out from other devices
          </Text>
          <Text
            button
            onPress={this.deleteAccount}
            light
            style={{ backgroundColor: "red" }}
          >
            Delete
          </Text>
        </View>*/}
      </ScrollView>
    );
  }

  setLightScheme = (scheme) => {
    this.setState({ lightScheme: scheme });
  };
  setDarkScheme = (scheme) => {
    this.setState({ darkScheme: scheme });
  };
  setSchemeMode = (mode) => {
    this.setState({ selectedSchemeMode: mode });
  };

  getPrefs = async () => {
    let fetchedPreferences = await prefActions.get();
    console.log(fetchedPreferences);
  };

  renderEvents = () => {
    let { events, composing, composingId, createdValues } = this.state;
    return events.map((event, i) => {
      if (composingId == event.id) {
        return this.renderComposer(event.id);
      } else if (!!createdValues.find((v) => v.event_id == event.id)) {
        let value = createdValues.find((v) => v.event_id == event.id);
        return (
          <View>
            <Text>wtf</Text>
            <MomentBullet moment={{ value }} />
          </View>
        );
      }
      let startAt = event.startAt;
      let startAtString = textHelpers.formatDate(startAt);
      let title = event.summary;
      return (
        <Text
          button
          key={i}
          style={styles.item}
          onPress={() => this.handleCompose(startAt, title, event)}
        >{`${startAtString} - ${title}`}</Text>
      );
    });
  };

  saveGCalCredentials = async () => {
    let { gCalServiceAccountJson } = this.state;
    if (!gCalServiceAccountJson) return;
    try {
      await calendarActions.saveServiceAccount(gCalServiceAccountJson);
      this.setState({ gCalConnected: true, gCalServiceAccountJson: "" });
      this.getEvents(true);
    } catch (e) {
      alert("Invalid JSON. Please paste the full service account key file.");
    }
  };

  disconnectGCal = async () => {
    await calendarActions.disconnect();
    this.setState({ gCalConnected: false, events: [] });
  };

  getEvents = async (silent = false) => {
    let events = await calendarActions.getEvents(false, silent);
    if (!!events) {
      console.log(events);
      this.setState({ events });
    }
  };

  handleCompose = (timestamp, text, event) => {
    this.setState({
      composing: true,
      composingId: event.id,
      parent: null,
      parentQuery: "",
      timestamp,
      text
    });
  };

  renderComposer = (event_id) => {
    let { composing, parent, parentQuery, timestamp, text, createdValues } =
      this.state;
    if (composing) {
      if (!parent) {
        return (
          <View style={{ padding: 10 }}>
            <Text>{text}</Text>
            <Autocomplete
              placeholder={"search for parent"}
              query={parentQuery}
              onChangeText={(text) => {
                this.setState({ parentQuery: text });
              }}
              simpleListView
              submitFirstOnPressEnter
              onSelectItem={(parent) => {
                this.setState({ parent, parentQuery: "" });
              }}
            />
            <Text button onPress={() => this.setState({ parent: {} })}>
              Skip
            </Text>
          </View>
        );
      }
      return (
        <ValueInspector
          // fullBleed={list}
          // style={list && { marginLeft: sizes.extraGiant }}
          composer
          createChapter
          parent={parent}
          value={parent}
          // onProgress={this.props.onProgress}
          // onCreateChild={this.props.onCreateChild}
          onClose={(newValue = {}) => {
            console.log(newValue);
            this.setState({
              composing: false,
              createdValues: [...createdValues, { ...newValue, event_id }]
            });
          }}
          text={text}
          date={timestamp}
        />
      );
    }
  };
}

const styles = StyleSheet.create({
  container: {
    // flex: 1,
    padding: sizes.base
    // alignItems: "flex-start",
  },
  header: {
    marginBottom: sizes.base
  },
  label: {
    width: 50,
    marginRight: sizes.base,
    textAlign: "right"
  },
  row: {
    flexDirection: "row",
    alignItems: "center",
    marginBottom: sizes.base,
    flexWrap: "wrap"
  },
  spacer: {
    height: sizes.giant
  },
  item: {
    backgroundColor: colors.empty,
    borderWidth: 1,
    borderColor: colors.trim
  },
  tokenInput: {
    borderWidth: 1,
    borderColor: colors.trim,
    padding: sizes.base,
    marginBottom: sizes.base,
    color: colors.text
  }
});
